import { cn } from '@mustauto/ui/web';
import type { InShopOrder } from '@mustauto/types/in-shop';

const OPTIONS: { key: InShopOrder; label: string }[] = [
  { key: 'location', label: 'Lugar' },
  { key: 'deadline', label: 'Prazo' },
];

/** Lugar (grupos, como sempre foi) ou prazo (uma lista só, do mais atrasado ao mais longe). */
export function InShopOrderToggle({ order, onChange }: { order: InShopOrder; onChange: (next: InShopOrder) => void }) {
  return (
    <div role="group" aria-label="Ordenar por" className="inline-flex overflow-hidden rounded-lg border border-input bg-card">
      {OPTIONS.map((o) => (
        <button
          key={o.key}
          type="button"
          aria-pressed={order === o.key}
          onClick={() => onChange(o.key)}
          className={cn(
            'px-3 py-1.5 text-sm',
            order === o.key ? 'bg-primary/10 font-semibold text-primary' : 'text-muted-foreground hover:bg-muted',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
